import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";
import AirTicketingDetails from "../components/AirTicketingDetails";

const AirTicketing = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"Air Ticketing"} />

      {/* Service Details Area */}
      <AirTicketingDetails />

      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default AirTicketing;
